import { Controller } from "@hotwired/stimulus"

// テーブル行全体をクリック可能にし、行の data-href が指す詳細ページへ遷移させる。
// 使い方: <tbody data-controller="row-link"
//           data-action="click->row-link#navigate auxclick->row-link#navigate"> に付け、
//         各 <tr> に data-href="/path" を持たせる。
// リンク/ボタン/フォーム部品など本来の操作を持つ要素上のクリックや、テキスト選択中は遷移しない。
// Cmd/Ctrl/中クリックは新規タブで開く（中クリックはモダンブラウザで auxclick として発火）。
export default class extends Controller {
  navigate(event) {
    // 左クリック(0)・中クリック(1)以外（右クリック等）は無視する
    if (event.button !== 0 && event.button !== 1) return

    // インタラクティブ要素上のクリックは本来の動作を優先して無視する
    if (event.target.closest("a, button, input, select, textarea, label, summary, [data-row-link-ignore]")) return
    // テキスト選択（ドラッグ）中は遷移しない
    if (window.getSelection()?.toString()) return

    const row = event.target.closest("[data-href]")
    if (!row || !this.element.contains(row)) return

    const url = row.dataset.href
    if (!url) return

    if (event.metaKey || event.ctrlKey || event.button === 1) {
      // 中クリック時のブラウザ自動スクロール（オートスクロール）を抑止する
      event.preventDefault()
      window.open(url, "_blank")
    } else if (window.Turbo) {
      window.Turbo.visit(url)
    } else {
      window.location.href = url
    }
  }
}
